<template>
  <div id="pick-supplier" class="fill-height align-start">
    <i-overlay
      v-if="loadingSuppliers || loadingSupplierData"
      :text="
        loadingSuppliers ? 'Loading Suppliers...' : 'Loading Supplier data...'
      "
    />

    <v-row v-else class="g-container" no-gutters>
      <v-col cols="12">
        <h2>Select supplier</h2>
      </v-col>

      <v-col cols="12">
        <v-card
          class="p-pick-store-card mx-auto rounded-lg mt-2 mt-md-4 pt-0 pa-4 mb-8"
          outlined
        >
          <v-card-text>
            <v-text-field
              dense
              label="Filter suppliers..."
              v-model="search"
            ></v-text-field>

            <div class="grey--text">Select a supplier:</div>
            <v-list class="px-0 p-list-suppliers" dense>
              <v-list-item
                class="px-1 px-md-4"
                :key="supplier.id"
                v-for="supplier in filteredSuppliers"
                @click="handleSelectSupplier(supplier)"
              >
                {{ supplier.name }}
              </v-list-item>
            </v-list>
          </v-card-text>

          <v-divider class="mx-4 mb-2 mb-md-4"></v-divider>

          <v-card-actions class="justify-center">
            <v-btn large rounded class="i-btn-block-secondary" @click="logout"
              >Sign out<v-icon>mdi-chevron-right</v-icon>
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import { fetchSuppliers } from '@/services/suppliers'
import iOverlay from '@/components/Overlay'
import { FTWebSocket } from '@/utils/FTWebSocket'

export default {
  components: {
    iOverlay
  },

  data: () => ({
    loadingSuppliers: true,
    loadingSupplierData: false,
    suppliers: [],
    search: ''
  }),

  computed: {
    ...mapState('auth', ['email']),

    filteredSuppliers() {
      return this.suppliers.filter((supplier) =>
        supplier.name.toLowerCase().includes(this.search.toLowerCase())
      )
    }
  },

  methods: {
    ...mapActions('auth', ['logout']),
    ...mapActions('tenant', ['fetchTenantSettings']),
    ...mapActions('bannerGroups', ['fetchAllBannerGroups']),
    ...mapActions('familyGroups', ['fetchFamilyGroups']),
    ...mapActions('freightInfo', ['fetchFreightInfo']),
    ...mapActions('creditReturns', [
      'fetchCreditReturnsStatusStatistics',
      'subscribeToCreditReturns'
    ]),
    ...mapActions('orderQueries', [
      'fetchQueryStatusStatistics',
      'subscribeToOrderQueries'
    ]),
    ...mapActions('purchaseOrders', [
      'fetchOrderStatistics',
      'subscribeToLiveOrders'
    ]),
    ...mapActions('pricingRegions', ['fetchPricingRegions']),
    ...mapActions('products', ['fetchProducts']),
    ...mapActions('preferences', ['setSelectedSupplier']),
    ...mapActions('multiStoreOperators', ['fetchAllMultiStoreOperators']),
    ...mapActions('stores', ['fetchAllRetailerStores']),
    ...mapActions('notifications', ['addNotification']),

    async handleSelectSupplier(supplier) {
      this.loadingSupplierData = true

      try {
        await this.setSelectedSupplier(supplier.id)
        this.loadingSupplierData = false
        await this.$router.push({ path: '/' })
      } catch (err) {
        this.loadingSupplierData = false
        this.addNotification({ color: 'error', defaultError: true })
      }
    }
  },

  async mounted() {
    // Disconnect the websocket connection here - this ensures that if switching supplier that any
    // previous subscriptions are cleared.  New subscriptions will be established once a supplier has been selected
    FTWebSocket.disconnect()

    fetchSuppliers().then((suppliers) => {
      this.loadingSuppliers = false
      if (suppliers.length === 1) return this.handleSelectSupplier(suppliers[0])
      else this.suppliers = suppliers
    })
  }
}
</script>

<style lang="scss" scoped>
#pick-supplier {
  .p-pick-store-card {
    margin-left: 16px;
    margin-right: 16px;
  }
}
</style>
